/**
 * Do any of the provided answers correspond to any of the provided questions?
 *
 * @param questions {Immutable.List<CoachingReviewTypeQuestion>} list of questions.
 * @param answers {Immutable.List<CoachingReviewAnswer>} list of answers.
 * @return {boolean} true if at least one of the questions has a corresponding answer.
 */
export default function anyQuestionHasAnAnswer(questions, answers) {
  if (!questions || questions.isEmpty()) {
    return false;
  }
  if (!answers || answers.isEmpty()) {
    return false;
  }
  const questionIds = questions.map(question => question.id).toSet();
  const firstAnswer = answers.find(answer => questionIds.has(answer.reviewQuestionId));
  return Boolean(firstAnswer);
}
